// Supabase Transform API Pro plan tələb edir.
// Business panel veb appdir — display üçün orijinal URL istifadə olunur.
// Sıxışdırma yalnız upload zamanı (compressImage.js) tətbiq edilir.

export function imgUrl(url) {
  return url || null;
}

export function thumbUrl(url) {
  return url || null;
}

export function heroUrl(url) {
  return url || null;
}

export function avatarUrl(url) {
  return url || null;
}
